import { render, staticRenderFns } from "./TutorialSelect.vue?vue&type=template&id=36f73e10&scoped=true"
import script from "./TutorialSelect.vue?vue&type=script&lang=js"
export * from "./TutorialSelect.vue?vue&type=script&lang=js"
import style0 from "./TutorialSelect.vue?vue&type=style&index=0&id=36f73e10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f73e10",
  null
  
)

export default component.exports